import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';


export default function CityCarousel({ city }) {
const images = {
"Dana Point": [
"https://alfalavista.s3.us-west-2.amazonaws.com/danaPoint.jpg",
"https://alfalavista.s3.us-west-2.amazonaws.com/2C5CA43C-B200-406B-BABB-5C056E0F0B5B.jpeg",
"https://alfalavista.s3.us-west-2.amazonaws.com/78E5B6A1-730F-4E9D-BE16-44573988606F.jpeg",
"https://alfalavista.s3.us-west-2.amazonaws.com/78E5B6A1-730F-4E9D-BE16-44573988606F.jpeg",
"https://alfalavista.s3.us-west-2.amazonaws.com/ADF3870C-9F11-4BE9-9C5C-ABA15812E9E4.jpeg"
],
// Add more cities if needed
};

const cityImages = images[city] || [];

return (
    <Carousel autoPlay infiniteLoop showThumbs={false}>
        {cityImages.map((src, index) => (
            <div key={index}>
                <img src={src} alt={`View of ${city} ${index + 1}`} />
            </div>
        ))}
    </Carousel>
);
}
